import { createActionCreators} from "../utils/actionCreators";

export const {
    request: getOrganizationsRequest,
    success: getOrganizationsSuccess,
    failure: getOrganizationsFailure
} = createActionCreators('GET_ORGANIZATIONS');